export const API_EXTERNAL_ENDPOINT = 'pueblos-landings'

export const API_INTERNAL_ENDPOINT = 'strapi/pueblos-landings/list'
